import Vue from 'vue'
import Router from 'vue-router'
import Guide from './views/Guide.vue'
import login from './views/login.vue'
import newlogin from './views/newlogin.vue'
import errorLoginPage from './views/errorLoginPage.vue'
// import register from './views/register.vue'

import home from './views/home.vue'
import tjPage from './views/tjPage.vue'
import xlPage from './views/xlPage.vue'
import xlDiaresPage from './views/xlDiaresPage.vue'
import xlDetialsPage from './views/xlDetialsPage.vue'
import faultDetialsPage from './views/faultDetialsPage.vue'

import BHDZPage from './views/BHDZPage'
import SOEPage from './views/SOEPage'
import FHQXPage from './views/FHQXPage'
import FHListPage from './views/FHListPage'
import XSJLPage from './views/XSJLPage'

import faultPage from './views/faultPage.vue'
import mlineDiaresPage from './views/mlineDiaresPage.vue'
import mlineHistoryDiaresPage from './views/mlineHistoryDiaresPage.vue'
import mlineContactPage from './views/mlineContactPage.vue'

import noticyPage from './views/noticyPage.vue'
import accountPage from './views/accountPage.vue'
import telhomePage from './views/telhomePage.vue'

import forgetPSWPage from './views/forgetPSWPage.vue'
import changetelPage from './views/changetelPage.vue'
import changepswPage from './views/changepswPage.vue'
import changeUserPage from './views/changeUserPage.vue'
import changeFacePage from './views/changeFacePage.vue'
import getMlinesPage from './views/getMlinesPage.vue'
import getCollectMlinesPage from './views/getCollectMlinesPage.vue'
import getDayDiaresPage from './views/getDayDiaresPage.vue'
import faultDiaresPage from './views/faultDiaresPage.vue'
import deviceStatusPage from './views/deviceStatusPage.vue'

import myPage from './views/myPage.vue'

Vue.use(Router)
var routes = [
  {
    path: '/guide', // 引导页
    name: 'guide',
    component: Guide
  },
  {
    path: '/', // 启动页
    name: 'launch',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ './views/Launch.vue')
  },
  {
    path: '/login', // 登录页
    name: 'login',
    component: login
  },
  {
    path: '/errorLoginPage', // 错误页面
    name: 'errorLoginPage',
    component: errorLoginPage
  },
  // {
  //   path: '/register', // 注册页
  //   name: ' register',
  //   component: register
  // },
  {
    path: '/home', // 首页
    name: 'home',
    component: home,
    redirect: '/tjPage', // 设置默认打开的页面
    children: [
      {
        path: '/tjPage', // 统计
        name: 'tjPage',
        component: tjPage
      },
      {
        path: '/xlPage', // 线路
        name: 'xlPage',
        component: xlPage
      },
      {
        path: '/faultPage', // 故障
        name: 'faultPage',
        component: faultPage
      },
      {
        path: '/myPage', // 我的
        name: 'myPage',
        component: myPage
      }
    ]
  },
  {
    path: '/xlDiaresPage',
    name: 'xlDiaresPage',
    component: xlDiaresPage,
    children: [
      {
        path: '/xlDetialsPage', // 线路详情
        name: 'xlDetialsPage',
        meta: {
          index: 3
        },
        component: xlDetialsPage
      },
      {
        path: '/faultDetialsPage', // 终端详情
        name: 'faultDetialsPage',
        component: faultDetialsPage
      }
    ]
  },
  {
    path: '/BHDZPage', // 保护定值
    name: 'BHDZPage',
    component: BHDZPage
  },
  {
    path: '/FHQXPage', // 负荷曲线
    name: 'FHQXPage',
    component: FHQXPage
  },
  {
    path: '/SOEPage', // SOE查询
    name: 'SOEPage',
    component: SOEPage
  },

  {
    path: '/FHListPage', // 负荷列表
    name: 'FHListPage',
    component: FHListPage
  },
  {
    path: '/XSJLPage', // 线损计量
    name: 'XSJLPage',
    component: XSJLPage
  },

  {
    path: '/mlineDiaresPage', // 线路故障统计
    name: 'mlineDiaresPage',
    component: mlineDiaresPage
  },
  {
    path: '/mlineHistoryDiaresPage', // 线路历史故障
    name: 'mlineHistoryDiaresPage',
    component: mlineHistoryDiaresPage
  },
  {
    path: '/mlineContactPage', // 线路联系人
    name: 'mlineContactPage',
    component: mlineContactPage
  },
  {
    path: '/getMlinesPage', // 所属线路
    name: 'getMlinesPage',
    component: getMlinesPage
  },
  {
    path: '/getCollectMlinesPage', // 收藏线路
    name: 'getCollectMlinesPage',
    component: getCollectMlinesPage
  },
  {
    path: '/getDayDiaresPage', // 今日故障
    name: 'getDayDiaresPage',
    component: getDayDiaresPage
  },
  {
    path: '/noticyPage', // 消息通知
    name: 'noticyPage',
    component: noticyPage
  },
  {
    path: '/accountPage', // 账号与安全
    name: 'accountPage',
    component: accountPage
  },
  {
    path: '/telhomePage', // 手机号
    name: 'telhomePage',
    component: telhomePage
  },
  {
    path: '/forgetPSWPage', // 忘记密码
    name: 'forgetPSWPage',
    component: forgetPSWPage
  },
  {
    path: '/changetelPage', // 验证手机号
    name: 'changetelPage',
    component: changetelPage
  },
  {
    path: '/changepswPage', // 修改密码
    name: 'changepswPage',
    component: changepswPage
  },
  {
    path: '/changeUserPage', // 个人信息
    name: 'changeUserPage',
    component: changeUserPage
  },
  {
    path: '/changeFacePage', // 头像信息
    name: 'changeFacePage',
    component: changeFacePage
  },
  {
    path: '/faultDiaresPage', // 故障详情
    name: 'faultDiaresPage',
    component: faultDiaresPage
  },
  {
    path: '/deviceStatusPage', // 设备状态
    name: 'deviceStatusPage',
    component: deviceStatusPage
  }
]
if (window.config.type === 1) {
  routes = [
    {
      path: '/guide', // 引导页
      name: 'guide',
      component: Guide
    },
    {
      path: '/', // 启动页
      name: 'launch',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Launch.vue')
    },
    {
      path: '/newlogin', // 自动登录页
      name: 'newlogin',
      component: newlogin
    },
    {
      path: '/errorLoginPage', // 错误页面
      name: 'errorLoginPage',
      component: errorLoginPage
    },
    // {
    //   path: '/register', // 注册页
    //   name: ' register',
    //   component: register
    // },
    {
      path: '/home', // 首页
      name: 'home',
      component: home,
      redirect: '/tjPage', // 设置默认打开的页面
      children: [
        {
          path: '/tjPage', // 统计
          name: 'tjPage',
          component: tjPage
        },
        {
          path: '/xlPage', // 线路
          name: 'xlPage',
          component: xlPage
        },
        {
          path: '/faultPage', // 故障
          name: 'faultPage',
          component: faultPage
        },
        {
          path: '/myPage', // 我的
          name: 'myPage',
          component: myPage
        }
      ]
    },
    {
      path: '/xlDiaresPage',
      name: 'xlDiaresPage',
      component: xlDiaresPage,
      children: [
        {
          path: '/xlDetialsPage', // 线路详情
          name: 'xlDetialsPage',
          meta: {
            index: 3
          },
          component: xlDetialsPage
        },
        {
          path: '/faultDetialsPage', // 终端详情
          name: 'faultDetialsPage',
          component: faultDetialsPage
        }
      ]
    },
    {
      path: '/BHDZPage', // 保护定值
      name: 'BHDZPage',
      component: BHDZPage
    },
    {
      path: '/FHQXPage', // 负荷曲线
      name: 'FHQXPage',
      component: FHQXPage
    },
    {
      path: '/SOEPage', // SOE查询
      name: 'SOEPage',
      component: SOEPage
    },
  
    {
      path: '/FHListPage', // 负荷列表
      name: 'FHListPage',
      component: FHListPage
    },
    {
      path: '/XSJLPage', // 线损计量
      name: 'XSJLPage',
      component: XSJLPage
    },
  
    {
      path: '/mlineDiaresPage', // 线路故障统计
      name: 'mlineDiaresPage',
      component: mlineDiaresPage
    },
    {
      path: '/mlineHistoryDiaresPage', // 线路历史故障
      name: 'mlineHistoryDiaresPage',
      component: mlineHistoryDiaresPage
    },
    {
      path: '/mlineContactPage', // 线路联系人
      name: 'mlineContactPage',
      component: mlineContactPage
    },
    {
      path: '/getMlinesPage', // 所属线路
      name: 'getMlinesPage',
      component: getMlinesPage
    },
    {
      path: '/getCollectMlinesPage', // 收藏线路
      name: 'getCollectMlinesPage',
      component: getCollectMlinesPage
    },
    {
      path: '/getDayDiaresPage', // 今日故障
      name: 'getDayDiaresPage',
      component: getDayDiaresPage
    },
    {
      path: '/noticyPage', // 消息通知
      name: 'noticyPage',
      component: noticyPage
    },
    {
      path: '/accountPage', // 账号与安全
      name: 'accountPage',
      component: accountPage
    },
    {
      path: '/telhomePage', // 手机号
      name: 'telhomePage',
      component: telhomePage
    },
    {
      path: '/forgetPSWPage', // 忘记密码
      name: 'forgetPSWPage',
      component: forgetPSWPage
    },
    {
      path: '/changetelPage', // 验证手机号
      name: 'changetelPage',
      component: changetelPage
    },
    {
      path: '/changepswPage', // 修改密码
      name: 'changepswPage',
      component: changepswPage
    },
    {
      path: '/changeUserPage', // 个人信息
      name: 'changeUserPage',
      component: changeUserPage
    },
    {
      path: '/changeFacePage', // 头像信息
      name: 'changeFacePage',
      component: changeFacePage
    },
    {
      path: '/faultDiaresPage', // 故障详情
      name: 'faultDiaresPage',
      component: faultDiaresPage
    },
    {
      path: '/deviceStatusPage', // 设备状态
      name: 'deviceStatusPage',
      component: deviceStatusPage
    }
  ]
}

export default new Router({
  routes: routes

})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
